import L from "leaflet";

export const mapboxPublicToken = "pk.eyJ1IjoibWFyaW5lbWFwcGluZyIsImEiOiJzM0Zxa2NJIn0.CsE3SQa_5YzTxA50eDsW8w";
export const osmAttributionText = "&copy; <a href='https://www.mapbox.com/about/maps/'>Mapbox</a> &copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> <strong><a href='https://www.mapbox.com/map-feedback/' target='_blank'>Improve this map</a></strong>";
// var mapboxAttributionText = "&copy; <a href='https://www.mapbox.com/about/maps/'>Mapbox</a> &copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> <strong><a href='https://www.mapbox.com/map-feedback/' target='_blank'>Improve this map</a></strong> &copy; <a href='https://www.digitalglobe.com/' target='_blank'>DigitalGlobe</a>";


export const MapBoxBackgroundMapping = L.tileLayer(
    "https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}?access_token=" + mapboxPublicToken,
    {attribution: osmAttributionText}
);

// export var MapBoxSatelliteMapping = L.tileLayer(
//     "https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v9/tiles/{z}/{x}/{y}?access_token=" + mapboxPublicToken,
//     {attribution: mapboxAttributionText}
// );

export function LegendGraphic(layerRef) {
    const url = mparc.wmsUrl + "?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&HEIGHT=20&WIDTH=20&LAYER="

    switch (layerRef) {
        case "MCZ":
            return url + "rc3:rc3_mczs"
        case "SAC":
            return url + "rc3:rc3_sacs"
        case "SPA":
            return url + "rc3:rc3_spas"
        case "NCMPA":
            return url + "rc3:rc3_ncmpas"
        case "Harbour porpoise SAC":
            return url + "rc3:rc3_sacs_harbour_porpoise"
        case "Closed demersal":
            return url + "rc3:rc3_closed_demersal"

        //
        case "embed_unrestricted":
            return url + "rc3:rc3_all_mpas_spatial"
        case "embed_consultation":
            return url + "rc3:rc3_view_future_measures"
        case "embed_banned":
            return url + "rc3:rc3_all_closures"
    }

}

// todo: what to do about these map layers on mpa browser pages?????
export const ClosedDemersal = L.tileLayer.wms(
    mparc.wmsUrl, {
        layers: "rc3:rc3_closed_demersal",
        format: 'image/png', transparent: true, tiled: true
});


export const AllMpas = L.tileLayer.wms(
    mparc.wmsUrl, {
        layers: "rc3:rc3_all_mpas_spatial",
        format: "image/png", transparent: true, tiled: true,
        rcvc: mparc.versionMetadata.version_code
});


export const AllClosures = L.tileLayer.wms(
    mparc.wmsUrl, {
        layers: "rc3:rc3_all_closures",
        format: "image/png", transparent: true, tiled: true,
        rcvc: mparc.versionMetadata.version_code  // this just updates when any changes have been made
});


export const PotentialFutureMeasures = L.tileLayer.wms(
    mparc.wmsUrl, {
        layers: "rc3:rc3_view_future_measures",
        format: "image/png", transparent: true, tiled: true,
        rcvc: mparc.versionMetadata.version_code
    }
)


export const MCZs = L.tileLayer.wms(
    mparc.wmsUrl, {
        layers: "rc3:rc3_mczs",
        format: 'image/png', transparent: true, tiled: true,
        rcvc: mparc.versionMetadata.mcz_dataset_version
});

export const SACs = L.tileLayer.wms(
    mparc.wmsUrl, {
        layers: "rc3:rc3_sacs",
        format: 'image/png', transparent: true, tiled: true,
        rcvc: mparc.versionMetadata.sac_dataset_version
});

export const SACsHarbourPorpoise = L.tileLayer.wms(
    mparc.wmsUrl, {
        layers: "rc3:rc3_sacs_harbour_porpoise",
        format: 'image/png', transparent: true, tiled: true,
        rcvc: mparc.versionMetadata.sac_dataset_version
});

export const SPAs = L.tileLayer.wms(
    mparc.wmsUrl, {
        layers: "rc3:rc3_spas",
        format: 'image/png', transparent: true, tiled: true,
        rcvc: mparc.versionMetadata.spa_dataset_version
});

export const NCMPAs = L.tileLayer.wms(
    mparc.wmsUrl, {
        layers: "rc3:rc3_ncmpas",
        format: 'image/png', transparent: true, tiled: true,
        rcvc: mparc.versionMetadata.ncmpa_dataset_version
});